import React from 'react';
import { Card, CardBody } from 'reactstrap';
import CountUp from "react-countup";

function Widget({ start=0, prefix='', suffix='', separator=',', end=0, decimals=0, duration=4, header="header", text='text', avatarIcon='fa-light fa-percent', avatarColorClass='avatar-blue' }) {
  return (
    <React.Fragment>
      <Card className={"card-height-100 "}>
        <CardBody>
          <div className="d-flex align-items-center">
            <div className="avatar-sm flex-shrink-0">
              <span className={"avatar-title " + avatarColorClass + " rounded fs-5 text-primary"}>
                <i className={avatarIcon}></i>
              </span>
            </div>
            <div className="flex-grow-1 ms-3">
              <p className={"text-uppercase fw-medium mb-3 text-muted"}>{header}</p>
              <h4 className={"fs-4 mb-3 fw-semibold ff-secondary"}><span className="counter-value">
                <CountUp
                  start={start}
                  prefix={prefix}
                  suffix={suffix}
                  separator={separator}
                  end={end}
                  decimals={decimals}
                  duration={duration}
                />
              </span></h4>
              <span className="text-muted" style={{ fontSize: "10px" }}>{text}</span>
            </div>
            {/* <p className="mb-0 text-muted"><span className="badge bg-danger-subtle text-danger mb-0"><i className="ri-arrow-down-line align-middle"></i> {item.statistic} </span></p> */}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default Widget
